export default __webpack_public_path__ + "static/media/expl-dissect_08_DE.9dd108a5.png";